import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import { pascalCase } from 'pascal-case';
import { ForwardedRef, RefObject } from 'react';
import { type MessageDescriptor } from 'react-intl';

export function isMessage(message: MessageDescriptor | unknown): message is MessageDescriptor {
    return message !== null && isObject(message) && typeof message.id !== 'undefined';
}

export function pad(n, width, z = '0') {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export function formatDuration(seconds) {
    const parts = [];
    const hours = Math.floor(seconds / (60 * 60));
    if (hours > 0) {
        parts.push(hours);
    }
    const minutes = Math.floor((seconds - hours * (60 * 60)) / 60);
    parts.push(hours > 0 && minutes < 10 ? `0${minutes}` : minutes);
    const remainingSeconds = Math.round(seconds - hours * (60 * 60) - minutes * 60);
    parts.push(remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds);
    return parts.join(':');
}

export function formatDurationIso8601(seconds) {
    const units = ['S', 'M', 'H'];
    return `PT${formatDuration(seconds)
        .split(':')
        .reverse()
        .map((it, index) => `${it}${units[index]}`)
        .reverse()
        .join('')}`;
}

export function getPrefixedProps(props, prefix) {
    return ((props !== null && !isArray(props) ? [props] : props) || []).reduce(
        (map, it) => ({
            ...map,
            [`${prefix}${pascalCase(it)}`]: true,
            [`${prefix === 'without' ? 'with' : 'without'}${pascalCase(it)}`]: false,
        }),
        null,
    );
}

export function getTrackingQuery({ recommendationId = null, clickRef = null } = {}) {
    if (recommendationId === null && clickRef === null) {
        return null;
    }
    return {
        ...(recommendationId !== null ? { _rid: recommendationId } : null),
        ...(clickRef !== null ? { _ref: clickRef } : null),
    };
}

export function mergeRefs<T>(...refs: Array<ForwardedRef<T> | null | undefined>) {
    return (value: T | null) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref != null) {
                (ref as RefObject<T | null>).current = value;
            }
        });
    };
}
